import { Injectable, Inject } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Config } from '../config/env.config';
import { BaseHttpService } from '../base/_base-http.service';
import { contentHeaders } from 'common/headers';
import * as _ from 'lodash';
import {catchError} from 'rxjs/operators';

@Injectable()
export class ImportManagerService extends BaseHttpService {

  fetch(brandId: string, page: number, itemsPerPage: number): Observable<any> {
      return this.http.get(
        Config.API +
        '/imports-upload/' + brandId +
        '?page=' + page + '&itemsPerPage=' + itemsPerPage
      )

          .pipe(catchError(this.handleError.bind(this)));
  }

  downloadErrorReport(brandId: string, partsImportId: string|number): Observable<any> {
    const url = `${Config.API}/parts-import-errors/${brandId}/${partsImportId}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'Accept': 'text/csv'
    });

    return this.http.get(url, { headers: headers, responseType: 'blob' });
  }
}
